<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="head-modal">
      <h2>Horários - Aprazamento</h2>
    </div>
    <div class="body-modal">
      @if (firstLoading) {
        <app-loading-list></app-loading-list>
      }
      @if (!firstLoading) {
        <form class="form" [formGroup]="model" (ngSubmit)="submit()">
          <div class="box">
            <div class="row details-content">
              <div class="col-4 details">
                <p><b>Material:</b></p>
                <p>{{this.prescriptionMedicineStruct.medicineName}}</p>
              </div>
              <div class="col-4 details">
                <p><b>Quantidade:</b></p>
                <p>{{this.prescriptionMedicineStruct.prescriptionMedicine.quantity}}</p>
              </div>
              <div class="col-4 details">
                <p><b>Unid.:</b></p>
                <p>{{this.prescriptionMedicineStruct.usage}}</p>
              </div>
              <div class="col-4 details">
                <p><b>Via:</b></p>
                <p>{{this.prescriptionMedicineStruct.usage}}</p>
              </div>
              <div class="col-4 details">
                <p><b>Frequência:</b></p>
                <p>{{this.prescriptionMedicineStruct.frequencyName}}</p>
              </div>
              <div class="col-4 details">
                <p><b>Diluição:</b></p>
                <p>{{this.prescriptionMedicineStruct.dilutionName}}</p>
              </div>
              <div class="col-4 details">
                <p><b>Apresentação:</b></p>
                <p>{{this.prescriptionMedicineStruct.presentationName}}</p>
              </div>
              <div class="col-4 details">
                <p><b>Período:</b></p>
                <p>{{this.prescriptionMedicineStruct.treatmentPeriodName}}</p>
              </div>
              <div class="col-4 details">
                <p><b>Observação da prescrição:</b></p>
                <p>{{this.prescriptionMedicineStruct.prescriptionMedicine.observation}}</p>
              </div>
            </div>
          </div>
          <div class="row box">
            <div class="title-subheader">
              <h3>Defina os horários</h3>
            </div>
            @if (hasActionsButton) {
              <span>Quantidade máxima permitida de aprazamento, conforme a sub-frequência definida pelo médico: {{model.get('listSchedulingDate')['controls'].length}}/{{prescriptionMedicineStruct.subFrequencyValue}}</span>
            }
            <div class="row scheduling-content">
              @for (item of model.get('listSchedulingDate')['controls']; track item; let i = $index) {
                <div class="col-12 col-md-6" formArrayName="listSchedulingDate"
                  >
                  <div [formGroupName]="i" appFormScroll>
                    <div class="row box">
                      <div class="col-12 col-sm-6">
                        <mat-form-field appearance="outline">
                          <mat-label>Data</mat-label>
                          <input matInput inputmode="text" type="text" [mask]="masks.date"
                            placeholder="dd/mm/aaaa" formControlName="date" (change)="i === 0 && changeFirstInput()">
                            @if (item.get('date').invalid) {
                              <mat-error>Data inválida</mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-12 col-sm-6">
                          <mat-form-field appearance="outline">
                            <mat-label>Horário</mat-label>
                            <input matInput type="text" formControlName="hour" [mask]="masks.timeUnit.mask"
                              [pattern]="masks.timeUnit.pattern" placeholder="00:00" (change)="i === 0 && changeFirstInput()">
                              @if (model.get('listSchedulingDate').hasError('datesNotInCrescentOrder')) {
                                <mat-error>
                                  A data deve estar em ordem crescente
                                </mat-error>
                              }
                              @if (!model.get('listSchedulingDate').hasError('datesNotInCrescentOrder') && item.get('hour').hasError('minOneHourDifference')) {
                                <mat-error>
                                  Intervalo tem que ser maior que 1 hora
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  @if (hasActionsButton) {
                    <div class="form-array-buttons col-12 col-sm-4 col-lg-2">
                      @if (prescriptionMedicineStruct.subFrequencyValue && model.get('listSchedulingDate')['controls'].length < prescriptionMedicineStruct.subFrequencyValue) {
                        <button class="side-button" color="primary" mat-mini-fab type="button"
                          (click)="addNextInputDate()"
                          [disabled]="buttonToSaveDisabled">
                          <mat-icon aria-hidden="false" aria-label="Menu apps">add</mat-icon>
                        </button>
                      }
                      @if (model.get('listSchedulingDate')['controls'].length > 1
                        && model.get('listSchedulingDate')['controls'].length !== this.prescriptionMedicineStruct.listPrescriptionMedicineCheck.length) {
                        <button class="side-button" color="primary" mat-mini-fab type="button"
                          (click)="removeLastSchedulingDate()"
                          [disabled]="buttonToSaveDisabled">
                          <mat-icon aria-hidden="false" aria-label="Menu apps">remove</mat-icon>
                        </button>
                      }
                    </div>
                  }
                </div>
                @if (model.get('listSchedulingDate').errors?.datesNotInCrescentOrder) {
                  <mat-error>
                    As datas devem estar em ordem crescente.
                  </mat-error>
                }
                @if (model.get('listSchedulingDate').hasError('minOneHourDifference')) {
                  <mat-error>
                    O horários devem ter intervalo mínimo de 1 em 1 hora.
                  </mat-error>
                }
                <div class="col-12">
                  <mat-form-field appearance="outline">
                    <mat-label>Observação sobre o planejamento</mat-label>
                    <textarea matInput type="text" formControlName="observation"></textarea>
                  </mat-form-field>
                </div>
              </div>
              <div class="row box">
                <div class="title-subheader">
                  <h3>Kits vinculados</h3>
                </div>
                @if (this.prescriptionMedicineStruct.listKit != null && this.prescriptionMedicineStruct.listKit.length > 0) {
                  <div class="card-list"
                    >
                    <div class="row row-list">
                      @for (item of this.prescriptionMedicineStruct.listKit; track item; let index = $index) {
                        <div class="col-12 col-sm-6"
                          >
                          <div class="card-item">
                            <div class="infos">
                              <span class="primary">{{item.kit.kitName}}</span>
                              <span class="secundary">{{item.kitType?.kitTypeName}}</span>
                            </div>
                            <div class="actions">
                              <a (click)="openKit(item)">
                                <mat-icon aria-hidden="false" aria-label="Visualizar">
                                  visibility
                                </mat-icon>
                              </a>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (this.prescriptionMedicineStruct.listKit == null
                  || this.prescriptionMedicineStruct.listKit.length == 0) {
                  <app-empty-list
                    [message]="'Não há kits vinculados'">
                  </app-empty-list>
                }
              </div>
              <div class="row box">
                <div class="title-subheader">
                  <h3>Materiais adicionais</h3>
                </div>
                @if (model.get('listMaterials')['controls'].length == 0) {
                  <div>
                    <button mat-flat-button type="button" class="add-item" color="primary"
                      (click)="addNextInputMaterial()" [disabled]="buttonToSaveDisabled">
                      @if (isLoading == false) {
                        <span>+ Adicionar material</span>
                      }
                      @if (isLoading == true) {
                        <mat-spinner [diameter]="30" class="mat-spinner-btn"
                        ></mat-spinner>
                      }
                    </button>
                  </div>
                }
                @if (model.get('listMaterials')['controls'].length > 0) {
                  <div>
                    @for (item of model.get('listMaterials')['controls']; track item; let i = $index) {
                      <div class="row" formArrayName="listMaterials"
                        >
                        <div class="col-12" [formGroupName]="i">
                          <div class="row">
                            <div class="col-12 col-sm-12 col-md-6">
                              <mat-form-field appearance="outline">
                                <mat-label>Selecione o material</mat-label>
                                <mat-select formControlName="kitItem">
                                  <hr>
                                    <mat-label><b>&nbsp; &nbsp; Kits &#8628;</b></mat-label>
                                    <hr>
                                      @for (kit of listKits; track kit) {
                                        <mat-option [value]="kit.idKit+'null'">
                                          {{kit.codeWithName}}
                                        </mat-option>
                                      }
                                      <hr>
                                        <mat-label><b>&nbsp; &nbsp; Materiais &#8628;</b></mat-label>
                                        <hr>
                                          @for (item of listItems; track item) {
                                            <mat-option [value]="'null'+item.idItem">
                                              {{item.itemName}}
                                            </mat-option>
                                          }
                                        </mat-select>
                                      </mat-form-field>
                                    </div>
                                    <div class="col-6 col-sm-6 col-md-3">
                                      <mat-form-field appearance="outline">
                                        <mat-label>Quantidade</mat-label>
                                        <input matInput type="number" formControlName="quantity" min="1"
                                          oninput="validity.valid||(value=null);" />
                                        </mat-form-field>
                                      </div>
                                      <div class="col-6 col-sm-6 col-md-3">
                                        <button class="side-button " color="primary" mat-mini-fab type="button"
                                          (click)="addNextInputMaterial()" [disabled]="buttonToSaveDisabled">
                                          <mat-icon aria-hidden="false" aria-label="Menu apps">add</mat-icon>
                                        </button>
                                        <button class="side-button " color="primary" mat-mini-fab type="button"
                                          (click)="removeInputMaterial(i)" [disabled]="buttonToSaveDisabled">
                                          <mat-icon aria-hidden="false" aria-label="Menu apps">remove</mat-icon>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </form>
                    }
                  </div>
                </div>
              </div>
              <div mat-dialog-footer class="footer-modal">
                <div class="row">
                  <div [ngClass]="{'col-md-6': !userCanSuspended, 'col-md-4': userCanSuspended}">
                    <button mat-flat-button type="button" color="primary" class=" btn-block" (click)="submit()"
                      [disabled]="buttonToSaveDisabled">
                      @if (isLoading == false) {
                        <span>Salvar</span>
                      }
                      @if (isLoading == true) {
                        <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                      }
                    </button>
                  </div>
                  @if (userCanSuspended) {
                    <div class="col-md-4">
                      <button mat-flat-button type="submit" color="accent" class=" btn-block" (click)="openPrescriptionModal()"
                        [disabled]="buttonToSaveDisabled">
                        @if (isLoading == false) {
                          <span>Suspender</span>
                        }
                        @if (isLoading == true) {
                          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                        }
                      </button>
                    </div>
                  }
                  <div [ngClass]="{'col-md-6': !userCanSuspended, 'col-md-4': userCanSuspended}">
                    <button mat-flat-button type="button" color="accent" class=" btn-block" (click)="close()">
                      @if (isLoading == false) {
                        <span>Cancelar</span>
                      }
                      @if (isLoading == true) {
                        <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                      }
                    </button>
                  </div>
                </div>
              </div>